import {Injectable, EventEmitter} from '@angular/core';

@Injectable()
export class NavbarService {
    public changeCategory$;
    public openMethodology$;

    constructor() {
        this.changeCategory$ = new EventEmitter();
        this.openMethodology$ = new EventEmitter();
    }

    changeCategory(data) {
        this.changeCategory$.emit(data);
    }

    openMethodology(data) {
        this.openMethodology$.emit(data);
    }
}



// WEBPACK FOOTER //
// ./src/app/services/connectors/navbar.service.ts